const selectors = {
  readMoreBtn: document.querySelectorAll('[data-btn-more]')
};
  class TemplatePubliclandingJS {
    constructor() {
      this.readMore();
    }
    readMore(){
      selectors.readMoreBtn.forEach(element => {
        if(element){
          let contentBlockHeight = element.closest('[data-readmorecontainer]').querySelector('[data-container]').scrollHeight;
          let newContentBlockHeight = element.closest('[data-readmorecontainer]').querySelector('[data-container]').offsetHeight;

          if (contentBlockHeight == newContentBlockHeight){
            element.closest('[data-readmorecontainer]').querySelector('[data-container]').style.height = 'auto';
            element.classList.add('d-none');
             element.classList.remove('d-inline-block');
          }
          element.addEventListener('click', (e)=> {
            e.preventDefault();
            let currentTarget = e.target;
            if(currentTarget.closest('[data-readmorecontainer]').classList.contains('open')){
              setTimeout(function () {
                currentTarget.closest('[data-readmorecontainer]').querySelector('[data-container]').style.height = '';
              }, 1);
              currentTarget.closest('[data-readmorecontainer]').classList.remove('open');
              currentTarget.innerHTML = 'Read More';
            } else {
              currentTarget.closest('[data-readmorecontainer]').querySelector('[data-container]').style.height = newContentBlockHeight + 'px';
              setTimeout(function () {
                currentTarget.closest('[data-readmorecontainer]').querySelector('[data-container]').style.height = contentBlockHeight + 'px';
              }, 1);
              setTimeout(function () {
                currentTarget.closest('[data-readmorecontainer]').classList.add('open');
              }, 300);
              currentTarget.innerHTML = 'Read Less';
            }

          });
        }
      });
    }
}

typeof TemplatePubliclandingJS !== 'undefined' && new TemplatePubliclandingJS();